module.exports = __webpack_public_path__ + "static/media/logo_200.4ccb684b.png";